import { Form, FormProps } from 'antd';
import { useTranslations } from '@/contexts/translation/useTranslations.tsx';

export interface PartnerRegistrationFormType {
  email: string;
  name: string;
  siren: string;
  orias: string;
  partner_code?: string;
  contact_firstname: string;
  contact_lastname: string;
  telephone: string;
  address: string;
  zipcode: string;
  city: string;
  country: number;
  password: string;
  password_confirm: string;
  referral_source: string;
  accept_cgu: boolean;
  /** Token Cloudflare Turnstile ; absent quand le captcha est désactivé. */
  'cf-turnstile-response'?: string;
}

interface UsePartnerRegistrationFormProps {
  onSubmit: (values: PartnerRegistrationFormType) => void;
}

const usePartnerRegistrationForm = ({
  onSubmit,
}: UsePartnerRegistrationFormProps) => {
  const [form] = Form.useForm<PartnerRegistrationFormType>();
  const { t } = useTranslations({ ns: 'window' });

  const onFinish: FormProps<PartnerRegistrationFormType>['onFinish'] = (
    values,
  ) => {
    onSubmit(values);
  };

  const defaultReferralOptions = [
    { value: 'search_engine', label: t('form.referral_option_search_engine') },
    { value: 'social_media', label: t('form.referral_option_social_media') },
    { value: 'word_of_mouth', label: t('form.referral_option_word_of_mouth') },
    { value: 'event', label: t('form.referral_option_event') },
    { value: 'other', label: t('form.referral_option_others') },
  ];

  return {
    t,
    form,
    onFinish,
    defaultReferralOptions,
  };
};

export default usePartnerRegistrationForm;
